module.exports = __webpack_public_path__ + "img/pravo.9a0d2f11.jpg";